import './zone-traffic-cell.scss';
import React, { useCallback, useMemo } from 'react';
import { RuleDataDao } from '../../../../dtos/version.dto';
import { getDisplayName } from '../../../../utils/string-normalization';
import { DynamicPlacementPopover } from '../../../shared/dynamic-placement-popover/dynamic-placement-popover';
import { useStores } from '../../../store';
import { addressGroupFullDataInfo } from '../../inventory/inventory-utils';

interface ZoneProps {
    ruleData: RuleDataDao;
    maxRegionsToDisplay?: number;
}

export const ZoneTrafficCell: React.FC<ZoneProps> = ({ ruleData, maxRegionsToDisplay = 5 }) => {
    const { fwVersionStore } = useStores();

    function isZone(zoneDir: string): boolean {
        return ruleData.zone.map(z => getDisplayName(z, 1))
            .includes(zoneDir);
    }

    const addressGroupHeight = fwVersionStore.selectedVersionAddressGroups.length * 20;

    const addressGroups = useMemo(() => {
        const allAddressGroups = fwVersionStore.selectedVersionAddressGroups;
        return allAddressGroups.filter(group => ruleData.address.address_groups?.includes(group.id));
    }, [ruleData]);

    const getAGDisplayName = useCallback((addressGroupId: string) => {
        return addressGroups.find(ag => ag.id === addressGroupId)?.displayName;
    }, [addressGroups]);

    const addressGroupCell =
        <div className={'table-cell-elements-container'}>
            {addressGroups?.length ?
                <DynamicPlacementPopover content={addressGroupFullDataInfo(addressGroups, fwVersionStore.getAddresses)}
                                         contentHeight={addressGroupHeight}>
                    {ruleData.address.address_groups.map(addressGroup=>
                        <div className={'table-cell-single-element'} key={addressGroup}>{getAGDisplayName(addressGroup)}</div>)}
                    </DynamicPlacementPopover> :
                <div>Any</div>}
        </div>;

    const edlsCell =
        <div>
            {ruleData.address.edls.length ? 'Global Block List' : 'Any'}
        </div>;

    const contentCell = ruleData.address.address_groups?.length ? addressGroupCell : edlsCell;

    return <div className={'zone-cell'}>
        {isZone('trust') && <div className={'status-label trust'}>My Network</div>}
        {isZone('untrust') && <div className={'status-label untrust'}>Internet</div>}
        {contentCell}
    </div>;
};